import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  role: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.role = action.payload.role;
    },
    logout: (state) => {
      state.role = null;
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;

export default authSlice.reducer;
